import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
var SvgCabinetFiling = function SvgCabinetFiling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "3.03442",
    y: "3.05176",
    width: "53.9983",
    height: "54.9037",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "3.03442",
    y: "3.05176",
    width: "53.9983",
    height: "54.9037",
    fill: "#FFF",
    opacity: 0.88
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M54.375 0H5.625C2.51836 0 0 2.51836 0 5.625V54.375C0 57.4816 2.51836 60 5.625 60H54.375C57.4816 60 60 57.4816 60 54.375V5.625C60 2.51836 57.4816 0 54.375 0ZM56.25 54.375C56.25 55.4086 55.4086 56.25 54.375 56.25H5.625C4.59141 56.25 3.75 55.4086 3.75 54.375V31.875H56.25V54.375ZM56.25 28.125H3.75V5.625C3.75 4.59141 4.59141 3.75 5.625 3.75H54.375C55.4086 3.75 56.25 4.59141 56.25 5.625V28.125ZM39.375 11.25H20.625C19.5891 11.25 18.75 12.0891 18.75 13.125V17.8125C18.75 18.3305 19.1695 18.75 19.6875 18.75H21.5625C22.0805 18.75 22.5 18.3305 22.5 17.8125V15H37.5V17.8125C37.5 18.3305 37.9195 18.75 38.4375 18.75H40.3125C40.8305 18.75 41.25 18.3305 41.25 17.8125V13.125C41.25 12.0891 40.4109 11.25 39.375 11.25ZM19.6875 48.75H21.5625C22.0805 48.75 22.5 48.3305 22.5 47.8125V45H37.5V47.8125C37.5 48.3305 37.9195 48.75 38.4375 48.75H40.3125C40.8305 48.75 41.25 48.3305 41.25 47.8125V43.125C41.25 42.0891 40.4109 41.25 39.375 41.25H20.625C19.5891 41.25 18.75 42.0891 18.75 43.125V47.8125C18.75 48.3305 19.1695 48.75 19.6875 48.75Z"
  })));
};
export default SvgCabinetFiling;